import { Subject } from 'rxjs';

export const toasterSubject = new Subject();

interface ToasterMessage {
  type: string;
  message: string;
  onClose?: () => void;
}

export const notifyToaster = ({ type, message, onClose }: ToasterMessage) => {
  toasterSubject.next({ type, message, onClose });
};
